export default __webpack_public_path__ + "static/portrait-fa22bee73922a503323ea1a8da53f5cf.jpg";